const keys = {
  house: 'house',
  communications: 'communications',
  transport: 'transport',
  personal: 'personal',
  eatout: 'eatout',
  holiday: 'holiday',
  food: 'food',
  leisure: 'leisure',
  health: 'health',
}

const config = {
  questionAnswerData: {
    cohabitingQuestion: {
      question: 'Will you be living with a partner?',
      answers: {
        A: 'On my own',
        B: 'With my partner'
      },
      images: {
        Q1AA: 'Q1-AA-csc.jpg',
        Q1AB: 'Q1-AB-csc.jpg',
      }
    },
    single: {
      [keys.house]: {
        question: 'How will you budget to maintain your home in retirement?',
        answers: {
          A: 'I’ll cover the basics and keep things ticking along',
          B: 'I’ll keep the place maintained with occasional updates',
          C: 'I’ll happily redecorate and do home improvements',
        },
        images: {
          Q2AC: 'Q2-AC-csc.jpg',
          Q2AB: 'Q2-AB-csc.jpg',
          Q2AA: 'Q2-AA-csc.jpg',
        }
      },
      [keys.communications]: {
        question: 'How would you describe your mobile, internet and streaming service needs?',
        answers: {
          A: 'Just the basics — enough for everyday use',
          B: 'A solid setup with some streaming included',
          C: 'Fast internet and plenty of streaming options',
        },
        images: {
          Q3AA: 'Q3-AA-csc.jpg',
          Q3AB: 'Q3-AB-csc.jpg',
          Q3AC: 'Q3-AC-csc.jpg',
        }
      },
      [keys.food]: {
        question: "Where will you do your food shopping?",
        answers: {
          A: "Mostly lower-cost supermarkets, I buy what I need",
          B: "Mainly mainstream supermarkets, balancing cost and quality",
          C: "Wherever I like, choosing what I want rather than worrying about price",
        },
        images: {
          Q4AA: 'Q4-AA-csc.jpg',
          Q4AB: 'Q4-AB-csc.jpg',
          Q4AC: 'Q4-AC-csc.jpg',
        }
      },
      [keys.eatout]: {
        question: "How often will you dine out or order take-away?",
        answers: {
          A: 'Now and then - mostly casual meals',
          B: 'Fairly regularly, probably every two weeks',
          C: 'Most weeks',
        },
        images: {
          Q5AA: 'Q5-AA-csc.jpg',
          Q5AB: 'Q5-AB-csc.jpg',
          Q5AC: 'Q5-AC-csc.jpg',
        }
      },
      [keys.transport]: {
        question: 'How will you get around?',
        answers: {
          A: "I'll mostly use public transport",
          B: "I'll run a modest car",
          C: "I'll run a comfortable car",
        },
        images: {
          Q6AA: 'Q6-AA-csc.jpg',
          Q6AB: 'Q6-AB-csc.jpg',
          Q6AC: 'Q6-AC-csc.jpg',
        }
      },
      [keys.holiday]: {
        question: 'What are your travel plans?',
        answers: {
          A: 'Just the odd short break or day trips',
          B: 'Regular trips around Australia',
          C: 'Travel around Australia, plus overseas trips from time to time',
        },
        images: {
          Q7AA: 'Q7-AA-csc.jpg',
          Q7AB: 'Q7-AB-csc.jpg',
          Q7AC: 'Q7-AC-csc.jpg',
        }
      },
      [keys.leisure]: {
        question: "How will you spend your free time?",
        answers: {
          A: 'Mostly low-cost activities, like days at the beach',
          B: 'Movies, local events and occassional outings',
          C: 'Regular shows, concerts and other ticketed events',
        },
        images: {
          Q8AA: 'Q8-AA-csc.jpg',
          Q8AB: 'Q8-AB-csc.jpg',
          Q8AC: 'Q8-AC-csc.jpg',
        }
      },
      [keys.personal]: {
        question: 'How much will you spend on clothes and personal care?',
        answers: {
          A: "I'm pretty low maintenance, so not much",
          B: "I'll treat myself now and again, but within my budget",
          C: "I love the occasional splurge",
        },
        images: {
          Q9AA: 'Q9-AA-csc.jpg',
          Q9AB: 'Q9-AB-csc.jpg',
          Q9AC: 'Q9-AC-csc.jpg',
        }
      },
      [keys.health]: {
        question: "What level of health cover will you have?",
        answers: {
          A: 'I\'ll rely on the public health system',
          B: 'I\'ll have basic private health cover',
          C: 'I\'ll have comprehensive private health cover',
        },
        images: {
          Q10AA: 'Q10-AA-csc.jpg',
          Q10AB: 'Q10-AB-csc.jpg',
          Q10AC: 'Q10-AC-csc.jpg',
        }
      },
    },
    // uncomment and populate below if we ever add different question/answer copy. Will also need to update config/index.js getQuestionAnswerData getter
    // cohabiting: {
    //   [keys.house]: {},
    //   [keys.transport]: {},
    //   [keys.personal]: {},
    //   [keys.eatout]: {},
    //   [keys.holiday]: {},
    //   [keys.food]: {},
    //   [keys.treat]: {},
    // }
  },
  currencySymbol: '$',
  inputs: {
    age: {
      min: 18,
      max: 100,
      currentValue: 20, // initial value
    },
    retirementAge: {
      min: 50,
      max: 100,
      currentValue: 70, //initial value
    },
    currentBalance: {
      min: 0,
      max: 1000000,
      currentValue: 0,  //initial value
    },
  },
  engine: {
    interestRate: 0.04,
    statePension: 9627.80,
    annuityRate: 20,
  }
};

export default config;
